import { MegaMenu } from "../../../components/common/mega-menu/mega-menu";

export default function Header() {
  let prevScrollTop = 0;
  let currentScrollTop = 0;
  let fxiHeaderScrollable = document.querySelector(".header_scrollable");
  const navbar = fxiHeaderScrollable && fxiHeaderScrollable;
  let fxiTopHeader = document.querySelector(".fxi-top-header");
  let navigationLink = document.querySelectorAll(".header_nav-link");
  let megaMenuItem = document.querySelectorAll(".mega-menu_link");


  navigationLink &&
    navigationLink.forEach((link) => {
      let menuWrapper = link.parentNode.querySelector(".mega-menu_wrapper");
      if (menuWrapper) {
        let megaMenu = new MegaMenu(menuWrapper);
        link.addEventListener("mouseover", () => {
          megaMenu && megaMenu.renderDefaultState();
        });
      }
    });

  megaMenuItem &&
    megaMenuItem.forEach((link) => {      
      link.addEventListener('click', (event) => {   
        if(!event.target.classList.contains('active')) {
          megaMenuItem.forEach((el) => {
            el.classList.remove('active');
          });    
          event.target.classList.add('active');   
        }             
      });
    });  

  window.addEventListener("scroll", function () {
    const a = window.scrollY;
    const b = fxiTopHeader && fxiTopHeader.clientHeight;

    currentScrollTop = a;

    if (prevScrollTop < currentScrollTop && a > b + b) {
      navbar && navbar.classList.add("scroll-down");
      fxiTopHeader.classList.remove("top-0");
    } else if (prevScrollTop > currentScrollTop && !(a <= b)) {
      navbar && navbar.classList.remove("scroll-down");
    }
    prevScrollTop = currentScrollTop;

    if (currentScrollTop === 0) {
      fxiTopHeader.classList.add("top-0");
    }

    let hamburgerMenu = document.getElementsByClassName("pull-left")[0];

    if (hamburgerMenu && !hamburgerMenu.classList.contains("collapsed")) {
      navbar && navbar.classList.remove("scroll-down");
    }
  });
}
